import PropTypes from 'prop-types';
export const inputPropTypes = {
  /**
   * Field name value as string
   */
  name: PropTypes.string.isRequired,
  /**
   * Boolean value if field is required
   */
  required: PropTypes.bool,
  /**
   * Additional classname
   */
  classname: PropTypes.string,
  /**
   * Placeholder value as string
   */
  placeholder: PropTypes.string,
  /**
   * Type value as string
   */
  type: PropTypes.string.isRequired
};